import { client } from '../../client';
import {
  TeacherAssignmentTypeEnum,
  TeacherdeleteAssignmentsWithTeachingStructureDocument,
  TeacherDeleteAssignmentsWithTeachingStructureMutation,
  TeacherDeleteAssignmentsWithTeachingStructureMutationVariables,
  TeacherGetAllMyLeafsDocument,
  TeacherGetAllMyLeafsQuery,
  TeacherGetAllMyLeafsQueryVariables,
  TeacherGetAssigmentByIdDocument,
  TeacherGetAssigmentByIdQuery,
  TeacherGetAssigmentByIdQueryVariables,
  TeacherGetMyTeachingStructureItemsDocument,
  TeacherGetMyTeachingStructureItemsQuery,
  TeacherGetMyTeachingStructureItemsQueryVariables,
  TeacherupdateAssignmentsWithTeachingStructureDocument,
  TeacherUpdateAssignmentsWithTeachingStructureMutation,
  TeacherUpdateAssignmentsWithTeachingStructureMutationVariables,
} from '../types';

export async function getMySubjects(
  variables: TeacherGetMyTeachingStructureItemsQueryVariables,
): Promise<
  Array<{ teaching_structure_id: string; subject: { name: string; icon?: string; id: string }; teaching_structure: { title: string } }>
> {
  try {
    const response = await client.query<TeacherGetMyTeachingStructureItemsQuery, TeacherGetMyTeachingStructureItemsQueryVariables>({
      query: TeacherGetMyTeachingStructureItemsDocument,
      variables,
      fetchPolicy: 'network-only',
    });

    // @ts-ignore
    return response.data.teacher_subject;
  } catch (e) {
    throw e;
  }
}

export async function getItemsForMySubject(variables: TeacherGetAllMyLeafsQueryVariables): Promise<
  Array<{
    id: string;
    title: string;
    parent_id?: string;
    assignments: Array<{ id: string; title: string; type: TeacherAssignmentTypeEnum }>;
  }>
> {
  try {
    const response = await client.query<TeacherGetAllMyLeafsQuery, TeacherGetAllMyLeafsQueryVariables>({
      query: TeacherGetAllMyLeafsDocument,
      variables,
      fetchPolicy: 'network-only',
    });
    return response.data.teaching_structure_leafs;
  } catch (e) {
    throw e;
  }
}

export async function getAssigmentById(
  variables: TeacherGetAssigmentByIdQueryVariables,
): Promise<Array<{ type: TeacherAssignmentTypeEnum; title: string; id: string; description?: string }>> {
  try {
    const response = await client.query<TeacherGetAssigmentByIdQuery, TeacherGetAssigmentByIdQueryVariables>({
      query: TeacherGetAssigmentByIdDocument,
      variables,
      fetchPolicy: 'network-only',
    });

    return response.data.assignments;
  } catch (e) {
    throw e;
  }
}
//

export async function updateAssigmentTS(variables: TeacherUpdateAssignmentsWithTeachingStructureMutationVariables) {
  try {
    const response = await client.mutate<
      TeacherUpdateAssignmentsWithTeachingStructureMutation,
      TeacherUpdateAssignmentsWithTeachingStructureMutationVariables
    >({
      mutation: TeacherupdateAssignmentsWithTeachingStructureDocument,
      variables,
    });

    return response.data.update_assignments;
  } catch (e) {
    throw e;
  }
}
export async function deleteAssigmentTS(variables: TeacherDeleteAssignmentsWithTeachingStructureMutationVariables) {
  try {
    const response = await client.mutate<
      TeacherDeleteAssignmentsWithTeachingStructureMutation,
      TeacherDeleteAssignmentsWithTeachingStructureMutationVariables
    >({
      mutation: TeacherdeleteAssignmentsWithTeachingStructureDocument,
      variables,
    });

    return response.data.delete_assignments;
  } catch (e) {
    throw e;
  }
}
